<template>
  <div v-if="visible" class="full-frequency">
    <ncs-empty-result v-if="emptyResult"/>
    <div v-else class="container">
      <div class="row">
        <div v-for="(frequencyPerValue, group) in subcorpusGroups" class="col-lg-6 p-1">
          <ncs-full-frequency-result-table :frequency-per-value="frequencyPerValue" :group="group"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import find from 'lodash/find'
  import pickBy from 'lodash/pickBy'
  import includes from 'lodash/includes'
  import Ncs from 'ncs'

  export default {
    extends: Ncs.defaultComponents.NcsFullFrequencyResult,
    computed: {
      subcorpus() {
        return find(this.$store.state.api.query.filters, {name: 'ncs_documents.subcorpus'}).value
      },
      subcorpusGroups() {
        return pickBy(this.resultGroups, (f, g) => {
          return includes(this.$ncsConfig.corefl.groups[this.subcorpus], g.split('.').pop())
        })
      }
    }
  }
</script>
